import type {IErrorMessage} from '@rlx/feim';

// use errorCode = -1 in order to fit with the IErrorMessage interface.
// Anyway will be overridden by data from logic response
export const CUSTOM_ERROR: IErrorMessage = {
    errorCode: -1
};

export const AUTHENTICATION_FAILED: IErrorMessage = {
    errorCode: 101,
    errorMessage: 'Authentication failed'
};

export const PLAYER_DISABLED: IErrorMessage = {
    errorCode: 104,
    errorMessage: 'Player disabled'
};

export const IP_BLOCKED: IErrorMessage = {
    errorCode: 105,
    errorMessage: 'IP blocked (country block)'
};

export const SESSION_EXPIRED: IErrorMessage = {
    errorCode: 503,
    errorMessage: 'Session missing or expired'
};

export const INSUFFICIENT_FUNDS: IErrorMessage = {
    errorCode: 506,
    errorMessage: 'Not enough funds for chosen bet size'
};

export const SESSION_MOVED: IErrorMessage = {
    errorCode: 520,
    errorMessage: 'Session moved to other browser'
};

export const LOGIN_ERROR: IErrorMessage = {
    errorCode: 521,
    errorMessage: 'Technical error during login'
};

export const PARTNER_CASHIER_ERROR: IErrorMessage = {
    errorCode: 522,
    errorMessage: 'Partner cashier error'
};

export const CASHIER_ERROR: IErrorMessage = {
    errorCode: 523,
    errorMessage: 'Cashier error'
};

export const GAME_DISABLED: IErrorMessage = {
    errorCode: 524,
    errorMessage: 'Game disabled'
};

export const PLAYER_BLOCKED: IErrorMessage = {
    errorCode: 531,
    errorMessage: 'Blocked from playing'
};

export const BLOCKED_REGION: IErrorMessage = {
    errorCode: 534,
    errorMessage: 'Login attempt comes from blocked region'
};
